import React from 'react'
import styled from 'react-emotion'
import { Helmet } from 'react-helmet'
import isEmpty from 'lodash/isEmpty'
import { ReactComponent as GalleryIcon } from '../svg/view-carousel.svg'
import { ReactComponent as VideoIcon } from '../svg/play.svg'
import Gallery from '../components/Gallery';
import VideoPlayer from '../components/VideoPlayer';

const MenuItem = styled('li')(({ active }) => ({
  color: active ? '#000' : '#999',
  cursor: 'pointer',
  flex: 1,
  fontSize: '.75em',
  fontWeight: 600,
  letterSpacing: 1,
  lineHeight: '1rem',
  margin: 0,
  padding: '20px 10px',
  position: 'relative',
  textAlign: 'center',
  textTransform: 'uppercase',

  '&::before': {
    background: 'linear-gradient(to right, #ea4f62, #af1531)',
    content: '""',
    display: active ? 'block' : 'none',
    height: 2,
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },

  svg: {
    fill: active ? '#000' : '#b8b8b8',
    height: '1rem',
    marginRight: 5,
    verticalAlign: 'middle',
    width: '1rem',
  },

  span: {
    verticalAlign: 'middle',
  }
}))

class WorkTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasImages: !isEmpty(props.data.work.edges[0].node.data.gallery),
      hasVideos: !isEmpty(props.data.work.edges[0].node.data.videos),
      currentMedia: isEmpty(props.data.work.edges[0].node.data.gallery) ? 'videos' : 'gallery'
    }
  }

  render() {
    const work = this.props.data.work.edges[0].node
    return (
      <article
        css={{
          backgroundColor: '#fff',
          overflow: 'hidden',
        }}
      >
        <Helmet>
          <title>{`${work.data.title.text}`} – Patrícia Marques</title>
          <meta name="description" content={work.data.content.text} />
        </Helmet>

        {
          this.state.hasImages &&
          this.state.currentMedia === 'gallery' &&
          <Gallery images={work.data.gallery} />
        }
        {
          this.state.hasVideos &&
          this.state.currentMedia === 'videos' &&
          <VideoPlayer videos={work.data.videos} />
        }
  
        <nav
          css={{
            boxShadow: '0 0px 5px rgba(0, 0, 0, .1), 0 -5px 5px rgba(0, 0, 0, .1)',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <ul
            css={{
              backgroundColor: '#fff',
              display: 'flex',
              listStyle: 'none',
              margin: 0,
              padding: 0,
              width: '100%',
            }}
          >
            {!isEmpty(work.data.gallery) &&
            <MenuItem
              onClick={() => this.setState({ currentMedia: 'gallery' })}
              active={this.state.currentMedia === 'gallery'}
            >
              <GalleryIcon />
              <span>Gallery</span>
            </MenuItem>}
            {!isEmpty(work.data.videos) &&
            <MenuItem
              onClick={() => this.setState({ currentMedia: 'videos' })}
              active={this.state.currentMedia === 'videos'}
            >
              <VideoIcon />
              <span>Videos</span>
            </MenuItem>}
          </ul>
        </nav>
  
        <div
          css={{
            padding: '60px 20px',
          }}
        >
          <h2 css={{ margin: 0, padding: 0 }}>{work.data.title.text}</h2>
          <ul
            css={{
              listStyle: 'none',
              margin: '10px 0 30px',
              padding: 0,
  
              li: {
                backgroundColor: '#b8b8b8',
                borderRadius: 50,
                color: '#fff',
                display: 'inline-block',
                fontSize: '.65em',
                letterSpacing: 1.5,
                margin: '0 3px 0 0',
                padding: '4px 7px',
                textTransform: 'uppercase',
              }
            }}
          >
            {work.tags.map((tag, key) =>
              <li key={key}>{tag}</li>
            )}
          </ul>
          <div
            dangerouslySetInnerHTML={{ __html: work.data.content.text }}
            css={{ marginTop: 30 }}
          />
        </div>
      </article>
    )
  }
}

export default WorkTemplate

export const pageQuery = graphql`
  query workQuery($uid: String!) {
    work: allPrismicWork(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          tags
          slugs
          data {
            title {
              text
            }
            gallery {
              image {
                localFile {
                  childImageSharp {
                    sizes(maxWidth: 1920, maxHeight: 1920, quality: 90, traceSVG: { color: "#021212" }, cropFocus: ATTENTION) {
                      ...GatsbyImageSharpSizes
                    }
                  }
                }
              }
            }
            content {
              text
            }
            videos {
              embed {
                title
                thumbnail: localFile {
                  childImageSharp {
                    square: sizes(maxWidth: 300, maxHeight: 300, quality: 90, traceSVG: { color: "#021212" }, cropFocus: ATTENTION) {
                      ...GatsbyImageSharpSizes
                    }
                  }
                }
                width
                height
                url: embed_url
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/work.js